import { render, staticRenderFns } from "./CreateGroupPage.vue?vue&type=template&id=485f09c0"
import script from "./CreateGroupPage.vue?vue&type=script&lang=ts"
export * from "./CreateGroupPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports